module.exports = __webpack_public_path__ + "static/media/connect-wallet-slide-3.15c6cc41.svg";